import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
var _excluded = ["getRecordIds"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import map from 'lodash/map';
import omit from 'lodash/omit';
import Fetcher from './Fetcher';
import jsonify from './jsonify';
export var PaginatedFetcher = /*#__PURE__*/function (_Fetcher) {
  function PaginatedFetcher() {
    var _this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      getRecordIds = _ref.getRecordIds,
      args = _objectWithoutProperties(_ref, _excluded);
    _classCallCheck(this, PaginatedFetcher);
    _this = _callSuper(this, PaginatedFetcher, [args]);
    _this.asyncResponseHandler = _this.paginatedResponseHandler;
    _this.getRecordIds = getRecordIds || function (json) {
      return map(json, 'id');
    };
    return _this;
  }
  _inherits(PaginatedFetcher, _Fetcher);
  return _createClass(PaginatedFetcher, [{
    key: "paginatedResponseHandler",
    value: function paginatedResponseHandler(response, request) {
      var _this2 = this;
      return jsonify(response).then(function (json) {
        var total = parseInt(response.headers.get('total'), 10);
        var perPage = parseInt(response.headers.get('per-page'), 10);
        var paginationData = {
          totalPages: 1,
          records: _this2.getRecordIds(json)
        };
        if (perPage > 0) paginationData.totalPages = Math.ceil(total / perPage);
        return [json, paginationData];
      });
    }
  }, {
    key: "appendQueryParams",
    value: function appendQueryParams(url, params) {
      return _superPropGet(PaginatedFetcher, "appendQueryParams", this, 3)([url, omit(params, 'stateKey')]);
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _superPropGet(PaginatedFetcher, "fetch", this, 3)([url, omit(params, 'stateKey')]));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }]);
}(Fetcher);
export default PaginatedFetcher;